import { render, staticRenderFns } from "./Teachers.vue?vue&type=template&id=d74933b6&scoped=true"
import script from "./Teachers.vue?vue&type=script&lang=js"
export * from "./Teachers.vue?vue&type=script&lang=js"
import style0 from "./Teachers.vue?vue&type=style&index=0&id=d74933b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74933b6",
  null
  
)

export default component.exports